import { computed } from '@vue/composition-api';
const useMapFields = (root, store, field, mutation) => computed({
    get() {
        return root.$store.state[store][field];
    },
    set(newValue) {
        root.$store.commit(mutation, newValue);
    }
});
export default useMapFields;
